export default __webpack_public_path__ + "static/media/180-180 (1).ee570122.png";